import { httpClientCMS } from './microservice-http-clients';

export const getPageData = pageName => httpClientCMS.get(`/${pageName}`);
